import React from 'react';
import {
  APPROVAL_STATUS,
  // CRANE_USES,
  SPOT_STATUS,
} from '../../utilities/constants';
import { CranesDropdown } from '../dropdowns/multi/Cranes';
import { FieldContractorUsersDropdown } from '../dropdowns/multi/FieldContractorUsers';
import { FieldGroupsDropdown } from '../dropdowns/multi/FieldGroups';
import { FieldTreeOperatableIdsDropdown } from '../dropdowns/multi/FieldTreeOperatableIds';

/**
 * 揚重機予定検索フォーム
 * @params total {int} // 取得総数
 * @params isOpened {boolean} // 開閉フラグ
 * @params tempSearchConditions {object} // 検索条件(保存用)
 * @params refreshed {boolean} // 検索条件クリアフラグ
 * @params callbacks {func} // イベントハンドラ
 */
export const CraneUsesSearchForm = ({
  total,
  isOpened,
  tempSearchConditions,
  callbacks,
  clearFlag,
}) => (
  <div className='crane-schedulelist__searchform'>
    <div className='search-form'>
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果<span className='bold'>{total}</span>件)
        </div>
        <button
          id='accordion-toggle'
          className={isOpened ? 'accordion__btn show' : 'accordion__btn'}
          onClick={() => callbacks.handleFormOpen()}
        />
        <button
          className='btn-text--sm'
          onClick={() => callbacks.clearConditions()}
        >
          検索条件クリア
        </button>
      </div>
      <div
        id='search-form-accordion'
        className={isOpened ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>ステータス</span>
                </div>
                <div className='form-element__list'>
                  <div className='element__item'>
                    <label htmlFor='radio-status-1' className='radio'>
                      <input
                        id='radio-status-1'
                        name='approval_flag'
                        type='radio'
                        value={APPROVAL_STATUS.unapproved.id}
                        onClick={e => callbacks.setSingleCondition(e)}
                        checked={
                          tempSearchConditions.approval_flag ==
                          APPROVAL_STATUS.unapproved.id
                        }
                      />
                      <i className='i-2x' />
                      <span>{APPROVAL_STATUS.unapproved.name}</span>
                    </label>
                  </div>
                  <div className='element__item'>
                    <label htmlFor='radio-status-2' className='radio'>
                      <input
                        id='radio-status-2'
                        name='approval_flag'
                        type='radio'
                        value={APPROVAL_STATUS.approval.id}
                        onClick={e => callbacks.setSingleCondition(e)}
                        checked={
                          tempSearchConditions.approval_flag ==
                          APPROVAL_STATUS.approval.id
                        }
                      />
                      <i className='i-2x' />
                      <span>{APPROVAL_STATUS.approval.name}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>スポット</span>
                </div>
                <div className='form-element__list'>
                  <div className='element__item'>
                    <label htmlFor='radio-spot-1' className='radio'>
                      <input
                        id='radio-spot-1'
                        name='spot_flag'
                        type='radio'
                        value={SPOT_STATUS.spot.id}
                        onClick={e => callbacks.setSingleCondition(e)}
                        checked={
                          tempSearchConditions.spot_flag == SPOT_STATUS.spot.id
                        }
                      />
                      <i className='i-2x' />
                      <span>{SPOT_STATUS.spot.name}</span>
                    </label>
                  </div>
                  <div className='element__item'>
                    <label htmlFor='radio-spot-2' className='radio'>
                      <input
                        id='radio-spot-2'
                        name='spot_flag'
                        type='radio'
                        value={SPOT_STATUS.normal.id}
                        onClick={e => callbacks.setSingleCondition(e)}
                        checked={
                          tempSearchConditions.spot_flag == SPOT_STATUS.normal.id
                        }
                      />
                      <i className='i-2x' />
                      <span>{SPOT_STATUS.normal.name}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>揚重機名</span>
                </div>
                <CranesDropdown
                  selectedValues={tempSearchConditions.crane_id}
                  onSelect={callbacks.dropdown}
                  clearFlag={clearFlag}
                />
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>協力会社</span>
                </div>
                <FieldTreeOperatableIdsDropdown
                  selectedValues={tempSearchConditions.field_tree_id}
                  onSelect={callbacks.dropdown}
                  isWholeSource={true}
                  clearFlag={clearFlag}
                  exceptionAllLoadedLimit={true}
                  isShowFinished={true}
                  isShowNoForeman={true}
                />
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>元請担当者</span>
                </div>
                <FieldContractorUsersDropdown
                  selectedValues={tempSearchConditions.manager_user_id}
                  onSelect={callbacks.dropdown}
                  clearFlag={clearFlag}
                />
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>グループ</span>
                </div>
                <FieldGroupsDropdown
                  selectedValues={tempSearchConditions.field_group_id}
                  onSelect={callbacks.dropdown}
                  clearFlag={clearFlag}
                />
              </div>
              <div className='form-element'>
                <div className='form-element__list'>
                  <button
                    className='btn-fixedsize--stay search-form__btn--align-to-element'
                    onClick={callbacks.setSearchCondition}
                  >
                    検索
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/searchmenus/CraneUses.jsx